import api from "src/shared/api";
import {
  ISidebarLinkResponse,
  ISidebarMenuLinksTransformedResponse,
} from "./types";

const partnerSidebarMenuLinksApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSidebarMenuLiks: build.query<ISidebarMenuLinksTransformedResponse, void>(
      {
        query: () => ({
          url: `/api/user-context`,
          method: "GET",
        }),
        transformResponse: (
          data: ISidebarLinkResponse,
        ): ISidebarMenuLinksTransformedResponse => ({
          menu: data.data.menu,
          notice: data.data.notice,
        }),
      },
    ),
  }),
});

export const { useGetSidebarMenuLiksQuery } = partnerSidebarMenuLinksApi;
